import { _ as _objectWithoutProperties, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-range-1-6-0{position:relative;font-size:0}.hcr-range__field-1-6-0{position:relative;height:30px;overflow:visible}.hcr-range__field-1-6-0:before{display:block;position:absolute;top:50%;width:100%;height:2px;margin-top:-1px;border-radius:5px;background:#ffad00;content:\"\"}.hcr-range-1-6-0 [type=range]{position:absolute;bottom:0;left:0;width:100%;height:30px;margin:0;padding:0;outline:none;background:transparent;overflow:visible;z-index:100;-webkit-appearance:none;-moz-appearance:none;appearance:none}.hcr-range-1-6-0 [type=range]::-webkit-slider-runnable-track{background:transparent;border:0 solid #ffad00}.hcr-range-1-6-0 [type=range]::-webkit-slider-thumb{width:30px;height:30px;border:2px solid #e1e1e1;border-radius:100%;background:#fff;cursor:pointer;position:relative;outline:0;z-index:1;-webkit-appearance:none;pointer-events:all}.hcr-range-1-6-0 [type=range]::-moz-range-track{border:0;background:transparent}.hcr-range-1-6-0 [type=range]::-moz-range-thumb{width:30px;height:30px;border:2px solid #e1e1e1;border-radius:100%;background:#fff;cursor:pointer;pointer-events:all}.hcr-range-1-6-0 [type=range]::-moz-focus-outer{border:0}.hcr-range-1-6-0 [type=range]::-ms-track{border:0;background:transparent;color:transparent}.hcr-range-1-6-0 [type=range]::-ms-fill-lower,.hcr-range-1-6-0 [type=range]::-ms-fill-upper{border:0;background:transparent}.hcr-range-1-6-0 [type=range]::-ms-thumb{width:30px;height:30px;border:2px solid #e1e1e1;border-radius:100%;background:#fff;cursor:pointer;margin-top:0}.hcr-range__value-1-6-0{display:inline-block;width:50%;margin-bottom:4px;font-size:14px;word-break:break-all}.hcr-range__value--max-1-6-0{text-align:right}.hcr-range__track-range-1-6-0{position:absolute;bottom:14px;height:2px;margin-top:-1px;background:#ffad00;z-index:0}.hcr-range__label-1-6-0{display:block;margin-bottom:6px;color:#444;font-size:16px;word-break:break-all}@media (min-width:1200px){.hcr-range__label-1-6-0{color:#757575}}.hcr-range__label--hidden-1-6-0{display:none}.hcr-range-1-6-0 [type=range]:focus{outline:0}.hcr-range--disabled-1-6-0 .hcr-range__field-1-6-0:before{background:#e1e1e1;opacity:.5}.hcr-range--disabled-1-6-0 .hcr-range__track-range-1-6-0{background:#e1e1e1;opacity:0}.hcr-range-1-6-0 input:disabled::-moz-range-thumb,.hcr-range--disabled-1-6-0 input::-moz-range-thumb{cursor:not-allowed}.hcr-range-1-6-0 input:disabled::-ms-thumb,.hcr-range--disabled-1-6-0 input::-ms-thumb{cursor:not-allowed}.hcr-range-1-6-0 input:disabled::-webkit-slider-thumb,.hcr-range--disabled-1-6-0 input::-webkit-slider-thumb{cursor:not-allowed}.hcr-range--double-1-6-0{pointer-events:none}.hcr-range--double-1-6-0 .hcr-range__field-1-6-0:before{background:#e1e1e1}",
map:{"hcr-range":"hcr-range-1-6-0","hcr-range__field":"hcr-range__field-1-6-0","hcr-range__value":"hcr-range__value-1-6-0","hcr-range__value--max":"hcr-range__value--max-1-6-0","hcr-range__track-range":"hcr-range__track-range-1-6-0","hcr-range__label":"hcr-range__label-1-6-0","hcr-range__label--hidden":"hcr-range__label--hidden-1-6-0","hcr-range--disabled":"hcr-range--disabled-1-6-0","hcr-range--double":"hcr-range--double-1-6-0"}};

var bem = Bem('range', styles);
var Range = function Range(_ref) {
  var disabled = _ref.disabled,
      displayValues = _ref.displayValues,
      extraClasses = _ref.extraClasses,
      format = _ref.format,
      id = _ref.id,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      rangeEnd = _ref.rangeEnd,
      step = _ref.step,
      rest = _objectWithoutProperties(_ref, ["disabled", "displayValues", "extraClasses", "format", "id", "label", "max", "min", "rangeEnd", "step"]);

  var $cover = null;
  var $hooks = [null, null];
  var range = [0, 0]; // early assing range values

  range[0] = _objectSpread2({}, rest).value || _objectSpread2({}, rest).defaultValue || 0;

  if (rangeEnd) {
    range[1] = rangeEnd.value || rangeEnd.defaultValue || 0;
  } // updates the styling


  function updateRange() {
    if ($cover && rangeEnd) {
      $cover.style.left = "".concat((range[0] + -min) / (max + -min) * 100, "%");
      $cover.style.right = "".concat(100 - (range[1] + -min) / (max + -min) * 100, "%");
    }

    return false;
  }

  function updateHooks() {
    for (var i = 0; i < $hooks.length; i += 1) {
      if ($hooks[i]) {
        $hooks[i].innerHTML = format(range[i]);
      }
    }
  } // handle for event


  function handle(e) {
    var parentHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    // update values if needed
    if (displayValues) {
      updateHooks();
    } // update UI


    updateRange(); // emit change event transparently

    parentHandler(e);
  }
  /* eslint-disable prefer-destructuring */
  // handle minimum range handle


  function handleMin(e, parentHandler) {
    range[0] = parseInt(e.target.value, 10);

    if (range[1] && range[0] >= range[1]) {
      e.target.value = range[1];
      range[0] = range[1];
    }

    handle(e, parentHandler);
  } // handle maximum range handle


  function handleMax(e, parentHandler) {
    range[1] = parseInt(e.target.value, 10);

    if (range[0] >= range[1]) {
      e.target.value = range[0];
      range[1] = range[0];
    }

    handle(e, parentHandler);
  }
  /* eslint-enable prefer-destructuring */


  return React.createElement("section", {
    className: bem.b({
      disabled: disabled,
      double: rangeEnd
    }, extraClasses)
  }, React.createElement("label", {
    htmlFor: id,
    className: bem.e('label')
  }, label), displayValues && React.createElement("span", {
    className: bem.e('value', 'min'),
    ref: function ref(c) {
      $hooks[0] = c;
    }
  }, format(range[0])), displayValues && rangeEnd && React.createElement("span", {
    className: bem.e('value', 'max'),
    ref: function ref(c) {
      $hooks[1] = c;
    }
  }, format(range[1])), React.createElement("div", {
    className: bem.e('field')
  }, React.createElement("input", _extends({
    min: min,
    max: max,
    step: step,
    type: "range",
    disabled: disabled
  }, rest, {
    onChange: function onChange(e) {
      return handleMin(e, _objectSpread2({}, rest).onChange);
    }
  })), rangeEnd && React.createElement("input", _extends({
    min: min,
    max: max,
    step: step,
    type: "range",
    disabled: disabled
  }, rangeEnd, {
    onChange: function onChange(e) {
      return handleMax(e, _objectSpread2({}, rangeEnd).onChange);
    }
  }))), React.createElement("div", {
    ref: function ref(c) {
      $cover = c;
      updateRange();
    },
    className: bem.e('track-range')
  }));
};
Range.displayName = 'Range';
Range.defaultProps = {
  disabled: false,
  displayValues: false,
  extraClasses: '',
  format: function format(val) {
    return val;
  },
  max: 500,
  min: 0,
  step: 1,
  rangeEnd: null
};
Range.propTypes = {
  /** Disables all inputs */
  disabled: PropTypes.bool,

  /** Control display of value labels */
  displayValues: PropTypes.bool,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Format method for display label */
  format: PropTypes.func,

  /** Id for the range slider */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Maximum value for the range */
  max: PropTypes.number,

  /** Minimum value for the range */
  min: PropTypes.number,

  /** Increment/decrement step */
  step: PropTypes.number,

  /** Activates range behaviour and provides rest props to second input field, use for events */

  /* eslint-disable react/forbid-prop-types */
  rangeEnd: PropTypes.object
};
var range = Injecss(Range, styles);

export { range as Range };
